// extracted by mini-css-extract-plugin
export default {"containerChart":"RadarChart_containerChart__8FXsO"};